import { render, staticRenderFns } from "./EditEmployesPage.vue?vue&type=template&id=59df6ed5&"
import script from "./EditEmployesPage.vue?vue&type=script&lang=ts&"
export * from "./EditEmployesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports